import { render, staticRenderFns } from "./WorkGroupItem.vue?vue&type=template&id=afef0f3c&scoped=true&"
import script from "./WorkGroupItem.vue?vue&type=script&lang=js&"
export * from "./WorkGroupItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afef0f3c",
  null
  
)

export default component.exports